import React, {useCallback} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {useRouteMatch} from 'react-router-dom'
import {useSrpQueryString} from 'components/Accommodation/BackToSearchButton/helpers'
import {DateGuestOverlayContainer} from 'components/Accommodation/DateGuestInput'
import {FacilitiesBottomSheet} from 'components/Accommodation/Facilities/FacilitiesBottomSheet'
import {GuestReviewsOverlayPage} from 'components/Accommodation/GuestReviewsOverlay'
import {LightboxGalleryWithOffer} from 'components/Accommodation/LightboxGalleryWithOffer/LightboxGalleryWithOffer'
import {LocationOverlayMobile} from 'components/Accommodation/LocationOverlay'
import {useUrlUpdater} from 'components/data/WithUrlUpdater'
import {RoundShareButton} from 'components/ShareButton'
import {ShareComponent, ShareType} from 'components/ShareButton/constants'
import {useContentHotelContext} from 'modules/accommodation/ContentHotelProvider'
import {getSearchBoxValues} from 'modules/searchBox/selectors'
import {toggle} from 'opticks'

import {Button} from '@daedalus/atlas/Button'
import {Icon} from '@daedalus/atlas/Icon'
import {getDevicePlatform} from '@daedalus/core/src/_web/utils/userAgent'
import {useTrackingTeam} from '@daedalus/core/src/analytics/hooks/useTrackingTeam'
import {trackEvent} from '@daedalus/core/src/analytics/modules/actions'
import {
  Action,
  Category,
  Entity
} from '@daedalus/core/src/analytics/types/Events'
import {TRACKING_TIMEOUT_BEFORE_NAVIGATING_AWAY} from '@daedalus/core/src/auth/modules/actions'
import {isReactNativeWebView} from '@daedalus/core/src/native'
import {AccommodationFloatingHeader} from '@daedalus/shared/src/accommodation/AccommodationFloatingHeader'

import {RoomsDetailOverlayContainer} from '../../RoomsDetailOverlayContainer'
import {AccommodationView} from './AccommodationView'

export const HotelAccommodationView = () => {
  const {hotel} = useContentHotelContext()
  const {checkIn, checkOut, rooms} = useSelector(getSearchBoxValues)
  const isAndroid = useSelector(getDevicePlatform) === 'android'
  const hotelId = hotel?.objectID
  const match = useRouteMatch<{hotelSlug: string}>()
  const {changeLocation} = useUrlUpdater()
  const team = useTrackingTeam()
  const dispatch = useDispatch()
  const query = useSrpQueryString(match.params.hotelSlug)
  const shareUrlParams = {
    hotelId,
    checkIn,
    checkOut,
    rooms,
    component: ShareComponent.HotelDetails
  }
  // TODO: consider refactoring and unifying functionality with desktop standalone in a hook like useHandleBackToSearch if 6cde7b20-bookingexp-standalone-ap-mobile-v5 wins
  const handleBackToSearch = useCallback(() => {
    const isRedirectFromStandalone = toggle(
      '6cde7b20-bookingexp-standalone-ap-mobile-v5',
      false,
      true
    )
    dispatch(
      trackEvent({
        category: Category.User,
        entity: Entity.HotelDetailsBackButton,
        action: Action.Clicked,
        team
      })
    )
    setTimeout(() => {
      if (isRedirectFromStandalone) {
        isReactNativeWebView() && isAndroid ? history.back() : window.close()
      } else changeLocation(query)
    }, TRACKING_TIMEOUT_BEFORE_NAVIGATING_AWAY)
  }, [changeLocation, query, dispatch, team])
  return (
    <>
      <AccommodationFloatingHeader
        rightSlot={
          <>
            <RoundShareButton
              shareParams={shareUrlParams}
              component={ShareComponent.HotelDetails}
              shareType={ShareType.ShareLink}
            />
          </>
        }
        leftSlot={
          <Button
            variant="secondary"
            isRounded
            isFloating
            iconStart={<Icon name="ChevronLeft" />}
            dataId="BackButton"
            onClick={handleBackToSearch}
            size="lg"
          />
        }
      />
      <AccommodationView hotel={hotel} hotelId={hotelId} />
      <LightboxGalleryWithOffer component="MobileHotelViewGalleryStaticOfferCTA" />
      <FacilitiesBottomSheet hotel={hotel} />
      <LocationOverlayMobile hotel={hotel} />
      <DateGuestOverlayContainer />
      <RoomsDetailOverlayContainer />
      <GuestReviewsOverlayPage hotel={hotel} />
    </>
  )
}
